// protobufjs 版本只用能 6.x 或以下
// https://chinabigpan.github.io/protobuf_docs_zh_cn/routes/examples.html
const $protoRoot = require('@public/proto/mtp.js')

/**
 * proto请求编码
 * @param protoName 
 * @param payload 
 * @returns 
 */
export async function encodeProto<T>(protoName: string, payload: T): Promise<Uint8Array> {
    const build = await $protoRoot.lookup(protoName)
    return build.encode(payload).finish()
}

/**
 * proto响应解码
 * @param protoName 
 * @param content 
 * @returns 
 */
export async function decodeProto<T>(protoName: string, content?: Uint8Array): Promise<T> {
    const build = await $protoRoot.lookup(protoName)
    // 注意：返回的结果是 Message 对象，直接使用可能会有数据结构问题
    const message = build.decode(content)
    // 使用 toJSON() 转换成普通对象
    return message.toJSON()
}